export default class HideNavigation {

    constructor() {
        this.navbarElement = document.getElementById("navbar");
        this.prevScrollPos = 0;
        this.currentScrollPos = window.scrollY;

        if (this.navbarElement) {
            this.init();
        }
    }

    init() {
        window.onscroll = () => {
            this.currentScrollPos = window.scrollY;

            if (this.prevScrollPos > this.currentScrollPos) {
                this.navbarElement.classList.remove("hide");
            } else {
                this.navbarElement.classList.add("hide");
            }
            
            this.prevScrollPos = this.currentScrollPos;
        }
    }
}
